module.exports = __webpack_public_path__ + "img/intro_video_text_bottom.44d9c132.png";